import { useGate, useStore } from 'effector-react'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { ViewOtherCharge } from '~/features/OtherCharges/ViewOtherCharges'
import { otherChargeModel } from '~/entities/OtherCharges'
import { formatDateTimeForUI } from '~/shared/lib/date'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { PageContainer, Container, PageTitle } from '~/shared/ui/Layout'
import { NotFound } from '~/shared/ui/NotFound'
import { QuickNavigation } from '~/shared/ui/QuickNavigation'

const quickNavigationOptions = [
  { label: 'Осн. информация', anchor: 'main' },
  { label: 'Нарушение', anchor: 'violation' },
  { label: 'Фото', anchor: 'photos' },
  { label: 'Оплата', anchor: 'payment' },
  { label: 'Получатель платежа', anchor: 'paymentReceiver' },
  { label: 'Выгрузка', anchor: 'unloadingData' },
]

export function ViewOtherChargePage() {
  const params = useParams<{ otherChargeId: string }>()
  const otherChargeId = params.otherChargeId as string
  useGate(otherChargeModel.Gate, { otherChargeId })
  const otherCharge = useStore(otherChargeModel.$otherCharge)
  const isLoading = useStore(otherChargeModel.requestOtherChargeFx.pending)

  const protocolNumber = otherCharge?.getProtocolNumber()
  const protocolDate = otherCharge?.getProtocolDate()
  const title = `Прочее начисление [${protocolNumber}] от ${
    protocolDate ? formatDateTimeForUI(protocolDate) : ''
  }`

  const otherChargeError = otherChargeModel.useOtherChargeError(otherChargeId)

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { title: 'Прочие начисления', link: '/other-charges' },
      { title: title },
    ],
    [title],
  )

  if (otherChargeError) {
    return <NotFound message='Не удалось загрузить прочее начисление' />
  }

  return (
    <PageContainer title={title}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <PageTitle loading={isLoading}>{title}</PageTitle>
      </Container>

      <ViewOtherCharge />

      <QuickNavigation options={quickNavigationOptions} />
    </PageContainer>
  )
}
